import styled from "@emotion/styled"

const ImageAbout = styled('div')(() => ({
    height: '340px',
    width: '600px',
    marginTop:'120px',
    borderRadius: '10px',
    backgroundImage: 'url(https://img.freepik.com/fotos-premium/inspecao-do-engenheiro-extintor-de-incendio-na-sala-de-controle_34936-1725.jpg?w=740)',
    backgroundSize: 'cover',
}))

export default ImageAbout